import instance from 'utils/axios/instance.axios';
import { ACCEPTANCE_REVIEW } from './_constant';

export const getDetail = (councilMemberId, projectProposalId, councilId) =>
  instance.get(ACCEPTANCE_REVIEW.GET_DETAIL, {
    params: { councilMemberId, projectProposalId, councilId },
  });

export const getDetailFile = (councilMemberId, projectProposalId, councilId) =>
  instance.get(ACCEPTANCE_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, projectProposalId, councilId },
  });

export const getAcceptanceCouncil = (projectProposalId, councilId) =>
  instance.get(ACCEPTANCE_REVIEW.GET_PROJECT_PROPOSAL_INFO, {
    params: { projectProposalId, councilId },
  });

export const getReviewerInfo = (userId, projectProposalId, councilId, referenceId = null) =>
  instance.get(ACCEPTANCE_REVIEW.GET_REVIEWER_INFO, {
    params: { userId, projectProposalId, referenceId, councilId },
  });

export const uploadDetailFile = (body = {}) =>
  instance.post(ACCEPTANCE_REVIEW.UPLOAD_DETAIL_FILE, body);

export const updateDetailFile = (body = {}) =>
  instance.patch(ACCEPTANCE_REVIEW.UPDATE_DETAIL_FILE, body);

export const submit = (body = {}) => instance.patch(ACCEPTANCE_REVIEW.SUBMIT, body);

export const createAcceptanceReview = (body = {}) =>
  instance.post(ACCEPTANCE_REVIEW.CREATE_REVIEW, body);

export const updateAcceptanceReview = (body = {}) =>
  instance.patch(ACCEPTANCE_REVIEW.UPDATE_REVIEW, body);

export const downloadFile = (body = {}) =>
  instance.post(ACCEPTANCE_REVIEW.DOWNLOAD_FILE, body, { responseType: 'blob' });

export const downloadPdfFile = ({
  projectProposalId,
  councilId,
  councilMemberId,
  referenceId = null,
}) =>
  instance.post(
    ACCEPTANCE_REVIEW.DOWNLOAD_PDF_FILE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadPdfTemplate = ({
  projectProposalId,
  councilId,
  councilMemberId,
  referenceId = null,
}) =>
  instance.post(
    ACCEPTANCE_REVIEW.DOWNLOAD_PDF_TEMPLATE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxFile = ({
  projectProposalId,
  councilId,
  councilMemberId,
  referenceId = null,
}) =>
  instance.post(
    ACCEPTANCE_REVIEW.DOWNLOAD_DOCX_FILE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxTemplate = ({
  projectProposalId,
  councilId,
  councilMemberId,
  referenceId = null,
}) =>
  instance.post(
    ACCEPTANCE_REVIEW.DOWNLOAD_DOCX_TEMPLATE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
